import { type SVGProps } from 'react';

/**
 * The GitHub mark.
 *
 * Lucide removed brand logos in v1, so the mark lives here rather than being
 * pulled from an icon set. Drawn as a single filled path so it inherits
 * `currentColor` and scales with the surrounding text like a lucide icon does.
 */
export function GithubIcon({ className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d="M12 .5C5.73.5.5 5.73.5 12.02c0 5.03 3.29 9.29 7.86 10.77.57.1.78-.25.78-.55v-1.93c-3.2.7-3.87-1.54-3.87-1.54-.53-1.34-1.29-1.7-1.29-1.7-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.71 1.26 3.37.96.1-.75.4-1.26.73-1.55-2.55-.29-5.24-1.28-5.24-5.71 0-1.26.45-2.29 1.19-3.1-.12-.29-.51-1.47.11-3.06 0 0 .96-.31 3.15 1.18a10.9 10.9 0 0 1 5.74 0c2.18-1.49 3.14-1.18 3.14-1.18.63 1.59.24 2.77.12 3.06.74.81 1.19 1.84 1.19 3.1 0 4.44-2.7 5.42-5.26 5.7.41.36.78 1.06.78 2.14v3.17c0 .31.2.66.79.55A11.52 11.52 0 0 0 23.5 12.02C23.5 5.73 18.27.5 12 .5Z" />
    </svg>
  );
}
